var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSv = function SvgIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12-.001A12 12 0 0 0 1.19 6.782H22.81a12 12 0 0 0-10.81-6.783M12 23.999a12 12 0 0 0 10.809-6.783H1.19A12 12 0 0 0 12 24"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M9.59 12.523 12 8.349l2.41 4.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M15.13 13.9 12 15.465 8.87 13.9v-2.087h6.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m14.951 8.527-1.106 1.107a2.609 2.609 0 1 1-3.69 0L9.05 8.527a4.174 4.174 0 1 0 5.903 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconSv;